import React from 'react';
import {
	FacebookIcon,
	FacebookShareButton,
	LinkedinIcon,
	LinkedinShareButton,
	XIcon,
	TwitterShareButton,
} from 'react-share';
import { useLocation } from 'react-router-dom';

import { useApplicationContext } from '@common/react/components/Core/Application/Application';
import BaseHostOptions from '@common/react/store/BaseHostOptions';

interface Props {
	size?: number;
}

const ShareLinks: React.FC<Props> = ({ size = 36 }) => {
	const location = useLocation();
	const { getHostOptions } = useApplicationContext();

	const hostOptions = getHostOptions<BaseHostOptions>();
	const url = `${hostOptions.hostServer}${location.pathname.slice(1)}`;

	return <div className="share-icons">
		<FacebookShareButton
			url={url}
		>
			<FacebookIcon size={size} round />
		</FacebookShareButton>
		<LinkedinShareButton
			url={url}
		>
			<LinkedinIcon size={size} round />
		</LinkedinShareButton>
		<TwitterShareButton
			url={url}
		>
			<XIcon size={size} round />
		</TwitterShareButton>
	</div>;
};

export default ShareLinks;
